/* Sandy Bella motion layer — generated by build_motion.py (selector list shared with luxe-motion.css). */
(function () {
  var root = document.documentElement;
  if (!root.classList.contains('luxe-motion')) return;             // motion not allowed on this visit
  var SEL = [
  '.luxe-cards__heading',
  '.luxe-cards__item',
  '.luxe-steps__eyebrow',
  '.luxe-steps__heading',
  '.luxe-steps__cell',
  '.luxe-steps__link',
  '.luxe-steps__inner > .button',
  '.luxe-feature__media',
  '.luxe-feature__eyebrow',
  '.luxe-feature__heading',
  '.luxe-feature__text',
  '.luxe-feature__content .button',
  '.featured-blog .title-wrapper-with-link',
  '.blog__post',
  '.featured-blog .blog__button',
  '.collapsible-content .collapsible-content__heading',
  '.collapsible-content .accordion',
  '.newsletter .inline-richtext',
  '.newsletter__subheading',
  '.newsletter-form',
  '.luxe-trust__item',
  '.product-grid > .grid__item:nth-child(n+5)',
  '.product__description li',
  '.luxe-designer__eyebrow',
  '.luxe-designer__heading',
  '.luxe-designer__cell',
  '.luxe-designer__faq',
  '.blog-articles__article:nth-child(n+4)',
  '.article-template__content',
  '.luxe-about__body',
  '.luxe-about__pillar',
  '.luxe-about__signature'
  ];
  var LINES = ['.luxe-steps__heading', '.luxe-feature__heading', '.collapsible-content .collapsible-content__heading', '.luxe-designer__heading'];
  var GROUPS = [];   // [parent, children]: the parent is observed, its children revealed together
  var mobile = window.matchMedia('(max-width: 749px)').matches;
  var STEP = mobile ? 70 : 95, CAP = 7;
  function wrapLines(h) {
    if (h.classList.contains('lm-lines-ready')) return;
    var chunks = [[]], nodes = Array.prototype.slice.call(h.childNodes);
    nodes.forEach(function (n) {
      if (n.nodeType === 1 && n.tagName === 'BR') { chunks.push([]); h.removeChild(n); return; }
      chunks[chunks.length - 1].push(n);
    });
    chunks.forEach(function (c) {
      if (!c.length) return;
      var line = document.createElement('span'); line.className = 'lm-line';
      var inner = document.createElement('span'); inner.className = 'lm-line__in';
      h.insertBefore(line, c[0]); c.forEach(function (n) { inner.appendChild(n); }); line.appendChild(inner);
    });
    h.classList.add('lm-lines-ready');
  }
  function targets(scope) {
    var list = [];
    SEL.forEach(function (s) { list = list.concat(Array.prototype.slice.call(scope.querySelectorAll(s))); });
    return list.filter(function (el, i) { return list.indexOf(el) === i; });
  }
  function docOrder(a, b) { return a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1; }
  var io = new IntersectionObserver(function (entries) {
    var batch = entries.filter(function (e) { return e.isIntersecting; }).map(function (e) { return e.target; }).sort(docOrder);
    batch.forEach(function (el, i) {
      var g = el.getAttribute('data-lm-group');
      if (g) {
        Array.prototype.forEach.call(el.querySelectorAll(g), function (c, k) { c.style.setProperty('--lm-d', (Math.min(i, CAP) * STEP + Math.min(k, CAP) * STEP) + 'ms'); c.classList.add('lm-in'); });
        io.unobserve(el); return;
      }
      if (el.classList.contains('lm-lines-ready')) {
        Array.prototype.forEach.call(el.querySelectorAll('.lm-line__in'), function (l, k) { l.style.setProperty('--lm-d', (Math.min(i, CAP) * STEP + k * 120) + 'ms'); });
      }
      el.style.setProperty('--lm-d', Math.min(i, CAP) * STEP + 'ms');
      el.classList.add('lm-in');
      io.unobserve(el);
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });
  function arm(scope) {
    LINES.forEach(function (s) { Array.prototype.forEach.call(scope.querySelectorAll(s), wrapLines); });
    targets(scope).forEach(function (el) { if (!el.classList.contains('lm-in')) io.observe(el); });
    GROUPS.forEach(function (gp) { Array.prototype.forEach.call(scope.querySelectorAll(gp[0]), function (el) { if (!el.hasAttribute('data-lm-group')) { el.setAttribute('data-lm-group', gp[1]); io.observe(el); } }); });
    root.classList.add('lm-armed');
  }
  function start() { arm(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  // sections re-rendered by the theme editor or by Dawn (e.g. variant / filter updates) get observed too
  document.addEventListener('shopify:section:load', function (e) { arm(e.target); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) { targets(document).forEach(function (el) { el.classList.add('lm-in'); }); GROUPS.forEach(function (gp) { Array.prototype.forEach.call(document.querySelectorAll(gp[0] + ' > *'), function (c) { c.classList.add('lm-in'); }); }); } });
})();
